import React from 'react'
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/auth';

export default function CompleteSetup({ children }) {
    const user = useAuthStore((state) => state.user);
    return user.initSetup ? children : <Navigate to='/auth/profile-setup' />
}
